export enum DonationsRouteName {
    Donations = 'donations',
    DonationsIncomeCreate = 'donations-income-create',
    DonationsIncomeUpdate = 'donations-income-update',
    DonationsExpenseCreate = 'donations-expense-create',
    DonationsExpenseUpdate = 'donations-expense-update',
    DonationsOrganizationCreate = 'donations-organization-create',
    DonationsOrganizationUpdate = 'donations-organization-update',
    DonationsOrganization = 'donations-organization',
    DonationsOrganizationDetail = 'donations-organization-detail',
    DonationsOrganizationCreateDonationIncome = 'donations-organization-create-donation-income',
    DonationsOrganizationUpdateDonationIncome = 'donations-organization-update-donation-income',
    DonationsOrganizationCreateDonationExpense = 'donations-organization-create-donation-expense',
    DonationsOrganizationUpdateDonationExpense = 'donations-organization-update-donation-expense',
    DonationsIndividual = 'donations-individual',
    DonationsIndividualDetail = 'donations-individual-detail'
}
